/*
Mixin that will fetch data according to the provided function,
BEFORE route enter happens, to avoid displaying contentless page

fetchData and handleData should be functions
fetchData should return a promise, and takes one argument
  route (the route object of the current page/the page being navigated to)
handleData returns nothing and should take two arguments
  data (any type, ideally from the promise from fetchData)
  vm (Vue instance, ie the 'this' in most components)

On route update, will display unstyled content unfortunately
but that's necessary because of the way we handle 
admin publisher/exchange modes

Preferably only use this on pages where data fetching takes
a negligible amount of time, to avoid damaging UX
*/

export default (fetchData, handleData) => {
  return {
    data () {
      return {
        preRouteDataFetcherLoading: false,
      }
    },
    created () {
      //fetches data if beforeRouteEnter hasn't been called
      //ie, if navigating from this page 
      //to this page with different url params
      this.$nextTick().then(() => {
        if (this.preRouteDataFetcherLoading === false) {
          let promise = fetchData(this.$route)
          if (promise) {
            promise.then((data) => {
              handleData(data, this)
            })
          }
        }
      })
    },
    beforeRouteEnter (to, from, next) {
      //fetch data before entering route, 
      //to avoid flash of contentless page
      let promise = fetchData(to)
      if (promise) {
        promise.then((data) => {
          next(vm => {
            vm.preRouteDataFetcherLoading = true
            handleData(data, vm)
          })
        })
      } else {
        next(vm => {
          vm.preRouteDataFetcherLoading = true
        })
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/mixins/preRouteDataFetcher.js